import React, { useContext } from 'react'
import { UserContext } from '../../App';
import resume from '../../assets/about/resume.png'
import './resume.css';

function Resumee() {
    const {theme,setTheme}=useContext(UserContext);

  return (
    <>

    <main className={theme==0?"resume-light":'resume-dark'} style={{paddingTop:"6rem"}}>
        <center><h2 id={theme==0?"type-light":"type-dark"}>Resume</h2></center>
        <section className='resume-main'>
            
                <img src={resume} alt="resume" />
            
        </section>
    </main>
    </>
  )
}

export default Resumee